import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwapHorizontalCircleFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.8943 18.8943C22.7019 15.0867 22.7019 8.91332 18.8943 5.10571C15.0867 1.2981 8.91338 1.2981 5.10577 5.10571C1.29816 8.9133 1.29816 15.0867 5.10577 18.8943C8.91336 22.7019 15.0867 22.7019 18.8943 18.8943ZM14.5303 6.46967C14.2374 6.17678 13.7626 6.17678 13.4697 6.46967C13.1768 6.76256 13.1768 7.23744 13.4697 7.53033L14.1893 8.25H8C7.58579 8.25 7.25 8.58579 7.25 9C7.25 9.41421 7.58579 9.75 8 9.75H14.1893L13.4697 10.4697C13.1768 10.7626 13.1768 11.2374 13.4697 11.5303C13.7626 11.8232 14.2374 11.8232 14.5303 11.5303L16.5303 9.53033C16.8232 9.23744 16.8232 8.76256 16.5303 8.46967L14.5303 6.46967ZM10.5303 13.5303C10.8232 13.2374 10.8232 12.7626 10.5303 12.4697C10.2374 12.1768 9.76256 12.1768 9.46967 12.4697L7.46967 14.4697C7.17678 14.7626 7.17678 15.2374 7.46967 15.5303L9.46967 17.5303C9.76256 17.8232 10.2374 17.8232 10.5303 17.5303C10.8232 17.2374 10.8232 16.7626 10.5303 16.4697L9.81066 15.75H16C16.4142 15.75 16.75 15.4142 16.75 15C16.75 14.5858 16.4142 14.25 16 14.25H9.81066L10.5303 13.5303Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgSwapHorizontalCircleFilled);
export default ForwardRef;
